// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__kRBE4","header":"PatientBlock_header__3G8o6","label":"PatientBlock_label__UJ-T6","option":"PatientBlock_option__gVb91"};